import { createContext, useContext } from 'react';

import type { DashboardNotification } from './types.js';

/** Where the real `get_msgs` fetch has got to (MYP-112) — see `NotificationsProvider`. */
export type NotificationsStatus = 'loading' | 'ready' | 'error';

export interface NotificationsState {
  notifications: DashboardNotification[];
  unreadCount: number;
  status: NotificationsStatus;
  /** Keyed by `notificationKey`, not a wire `id` — the real endpoint sends no such field. */
  /** Marks one message read, here and on the vendor (`set_msgs_read`, MYP-70). */
  markRead: (key: string) => void;
  /** Marks every unread message read, here and on the vendor (one request per type). */
  markAllRead: () => void;
  /** Retries the fetch after `status` is `'error'`. */
  reload: () => void;
}

export const NotificationsContext = createContext<NotificationsState | null>(null);

/**
 * Read state lives above the routes so the shell badges and the list agree: opening a
 * notification anywhere decrements the header bell and the sidebar counts at the same time.
 */
export function useNotifications(): NotificationsState {
  const value = useContext(NotificationsContext);
  if (!value) throw new Error('useNotifications must be used inside <NotificationsProvider>');
  return value;
}
